import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer custom-footer pt-5 pb-3 mt-auto mb-0">
      <div className="container">
        <div className="row">

          {/* Brand & About Section */}
          <div className="col-md-3 mb-4">
            <h4 className="fw-bold">eSevaLinks</h4>
            <p>
              eSevaLinks is a one-stop platform that connects citizens with verified
              Central and State Government schemes and services. Our goal is to make
              accessing Sarkari resources simple and transparent.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Quick Links</h5>
            <ul className="list-unstyled mt-2">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer-link">Terms & Conditions</Link></li>
              <li><Link to="/disclaimer" className="footer-link">Disclaimer</Link></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Contact Information</h5>
            <ul className="list-unstyled mt-2">

              <li className="footer-contact-item">
                <i className="bi bi-envelope-fill me-2"></i>
                support@esevalink.com
              </li>

              <li className="footer-contact-item mt-2">
                <i className="bi bi-phone-fill me-2"></i>
                 020-4509-3482
              </li>

              <li className="footer-contact-item mt-2">
                <i className="bi bi-geo-alt-fill me-2"></i>
                Pune, Maharashtra, India
              </li>

            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Follow Us</h5>
            <div className="d-flex gap-3 mt-3">
              <a href="https://www.facebook.com/profile.php?id=61583892213220" className="social-icon fs-4"><FaFacebook /></a>
              <a href="https://www.instagram.com/e_seva_link/" className="social-icon fs-4"><FaInstagram /></a>
              <a href="http://www.youtube.com/@eSevaLink" className="social-icon fs-4"><FaYoutube /></a>
            </div>
          </div>

        </div>

        <hr className="border-secondary" />

        {/* Bottom Section */}
        <div className="text-center">
          <p className="mb-1">
            © 2025 <span className="fw-bold">eSevaLinks</span>. All rights reserved.
          </p>

          <p className="mb-0 small text-muted">
            Design and Developed by{" "}
            <a
              href="https://fouriseindia.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none fw-semibold"
              style={{ color: "#fe6e03" }}
            >
              Fourise Software Solutions Pvt. Ltd.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
